import styled, { css } from 'styled-components';

export const EditAddressStyled = styled.div.attrs({
  className: 'edit-address',
})`
  ${({ theme, fontColorTheme }) => {
    const { colors = {}, media = {} } = theme;
    const fontColor = fontColorTheme === 'dark' ? colors.primary.darkBlue : colors.primary.white;
    return css`
      ${media.mobile.down} {
        text-align: center;
        margin-bottom: 24px;
      }

      .edit-address {
        &__quote_number {
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
        }

        &__title {
          align-items: center;
          color: ${fontColor};
          display: flex;
          font-size: 1rem;
          font-weight: 500;
          justify-content: center;
          line-height: 16px;
          margin-top: 16px;
          margin-bottom: 0.5rem;

          ${media.tablet.up} {
            justify-content: flex-start;
          }

          span {
            color: ${fontColor};
          }

          svg {
            display: inline-block;
            height: 22px;
            margin-right: 0.5rem;
            position: relative;
            top: 1px;

            path {
              fill: ${fontColor};
            }
          }
        }

        &__button {
          background: none;
          border: 0;
          color: ${fontColor};
          cursor: pointer;
          font-size: 1rem;
          line-height: 17px;
          padding: 0;
          margin: 0;

          span {
            color: ${fontColor};
            font-weight: 500;
            margin-left: 5px;
            text-decoration: underline;
          }
        }
      }
    `;
  }}
`;

export const EditAddressQuoteStyled = styled.div<{
  showSaveQuoteButton?: boolean;
}>`
  ${({ theme, showSaveQuoteButton }) => {
    const { media = {} } = theme;
    return showSaveQuoteButton
      ? css`
          display: flex;
          align-items: center;
          gap: 10px;
          justify-content: center;
          flex-direction: column;
          ${media.tablet.up} {
            flex-direction: row;
          }
        `
      : '';
  }}
`;
